:host { all: initial; }
* { box-sizing: border-box; font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif; }

.dc {
  --bg: #ffffff; --fg: #0f172a; --muted: #64748b; --border: #e5e7eb;
  --card: #f8fafc; --grad: linear-gradient(135deg,#1e9bf0,#6d31e6);
}
.dc.dark {
  --bg: #0f1115; --fg: #e5e7eb; --muted: #94a3b8; --border: #232733; --card: #171a21;
}

/* floating phone */
.dc-wrap {
  position: fixed; z-index: 2147483000; width: 232px;
  border-radius: 16px; overflow: hidden; background: var(--bg); color: var(--fg);
  box-shadow: 0 14px 40px rgba(0,0,0,.22); border: 1px solid var(--border); font-size: 13px;
}
.dc-head {
  display: flex; align-items: center; justify-content: flex-end; gap: 2px;
  padding: 7px 8px 0; background: var(--bg); cursor: grab; user-select: none;
}
.dc-ico {
  background: none; border: none; color: var(--muted); width: 26px; height: 26px;
  border-radius: 8px; cursor: pointer; font-size: 14px; display: inline-flex; align-items: center; justify-content: center;
}
.dc-ico:hover { background: var(--card); color: var(--fg); }
.dc-body { padding: 4px 14px 12px; display: flex; flex-direction: column; gap: 10px; }
.dc-foot { padding: 2px 12px 8px; text-align: left; font-size: 10px; color: var(--muted); }

.dc-label { font-size: 12px; color: var(--muted); }
.dc-disp { text-align: center; font-size: 20px; font-weight: 500; min-height: 26px; letter-spacing: 1px; color: var(--fg); word-break: break-all; }
.dc-disp.ph { color: var(--muted); font-weight: 400; }

.dc-keys { display: grid; grid-template-columns: repeat(3,52px); justify-content: center; gap: 10px; }
.dc-key {
  width: 52px; height: 52px; border-radius: 50%; border: none; background: var(--card); color: var(--fg);
  cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center; line-height: 1;
}
.dc-key:active { transform: scale(.94); }
.dc-key b { font-size: 18px; font-weight: 600; }
.dc-key span { font-size: 8px; color: var(--muted); letter-spacing: 1px; margin-top: 1px; }

.dc-actions { display: grid; grid-template-columns: 1fr 50px 1fr; align-items: center; gap: 8px; margin-top: 2px; }
.dc-call { grid-column: 2; width: 50px; height: 50px; border-radius: 50%; border: none; background: #16a34a; color: #fff; font-size: 20px; cursor: pointer; justify-self: center; }
.dc-call.end { background: #dc2626; }
.dc-bksp { background: none; border: none; color: var(--muted); font-size: 17px; cursor: pointer; justify-self: start; grid-column: 3; }

.dc-line { width: 100%; padding: 8px 10px; border: 1px solid var(--border); border-radius: 10px; background: var(--bg); color: var(--fg); font-size: 13px; }

/* call/incoming screens */
.dc-center { text-align: center; }
.dc-av { width: 64px; height: 64px; border-radius: 50%; margin: 6px auto; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 26px; background-image: var(--grad); overflow: hidden; }
.dc-av-img { width: 100%; height: 100%; object-fit: cover; border-radius: 50%; }
.dc-peer { font-size: 18px; font-weight: 700; margin: 4px 0; }
.dc-status { color: var(--muted); font-size: 13px; }
.dc-peer-mute {
  display: inline-flex; align-items: center; gap: 5px; align-self: center;
  padding: 3px 8px; border-radius: 999px; border: 1px solid var(--border);
  background: var(--card); color: var(--muted); font-size: 11px; font-weight: 500;
  max-width: 100%; text-align: left; line-height: 1.25;
}
.dc-peer-mute-ico { flex-shrink: 0; }
.dc-timer { font-variant-numeric: tabular-nums; font-size: 22px; font-weight: 700; margin: 6px 0; }
.dc-row { display: flex; gap: 10px; }
.dc-row > * { flex: 1; }
.dc-btn { border: none; border-radius: 12px; padding: 11px; font-size: 15px; font-weight: 600; color: #fff; cursor: pointer; }
.dc-accept { background: #16a34a; } .dc-reject, .dc-endbtn { background: #dc2626; } .dc-sec { background: #475569; } .dc-sec.on { background: #94a3b8; }

/* settings modal */
.dc-ovl { position: fixed; inset: 0; z-index: 2147483600; background: rgba(0,0,0,.45); display: flex; align-items: center; justify-content: center; padding: 16px; }
.dc-modal { width: 100%; max-width: 460px; max-height: 86vh; overflow-y: auto; background: var(--bg); color: var(--fg); border-radius: 16px; box-shadow: 0 20px 60px rgba(0,0,0,.4); }
.dc-mhead { display: flex; align-items: flex-start; justify-content: space-between; padding: 16px 18px 8px; }
.dc-mtitle { font-size: 18px; font-weight: 700; }
.dc-msub { font-size: 13px; color: var(--muted); }
.dc-tabs { display: flex; gap: 6px; margin: 6px 14px 12px; background: var(--card); padding: 5px; border-radius: 12px; }
.dc-tab { flex: 1; padding: 8px; border: none; background: none; color: var(--muted); border-radius: 9px; cursor: pointer; font-size: 13px; font-weight: 600; }
.dc-tab.on { background: var(--bg); color: var(--fg); box-shadow: 0 1px 3px rgba(0,0,0,.1); }
.dc-mbody { padding: 0 16px 18px; display: flex; flex-direction: column; gap: 12px; }

.dc-input { width: 100%; padding: 10px; border: 1px solid var(--border); border-radius: 10px; background: var(--bg); color: var(--fg); font-size: 14px; }
.dc-add { display: flex; gap: 8px; }
.dc-plus { width: 42px; border: none; border-radius: 10px; background: #16a34a; color: #fff; font-size: 20px; cursor: pointer; }

.dc-dev { border: 1px solid var(--border); border-radius: 12px; padding: 12px; }
.dc-dev-top { display: flex; align-items: center; justify-content: space-between; }
.dc-st { display: flex; align-items: center; gap: 6px; font-size: 13px; }
.dc-dot { width: 9px; height: 9px; border-radius: 50%; }
.dc-dot.on { background: #16a34a; } .dc-dot.off { background: #dc2626; }
.dc-dev-tok { display: flex; align-items: center; gap: 8px; margin-top: 8px; font-size: 12px; color: var(--muted); font-family: ui-monospace, monospace; }
.dc-mini { background: none; border: none; color: var(--muted); cursor: pointer; font-size: 14px; }
.dc-tg { width: 38px; height: 22px; border-radius: 11px; background: var(--border); position: relative; cursor: pointer; border: none; }
.dc-tg.on { background: #16a34a; }
.dc-tg i { position: absolute; top: 2px; left: 2px; width: 18px; height: 18px; border-radius: 50%; background: #fff; transition: left .15s; }
.dc-tg.on i { left: 18px; }
.dc-trash { background: none; border: none; color: #dc2626; cursor: pointer; font-size: 15px; }

.dc-sec-box { border: 1px solid var(--border); border-radius: 12px; padding: 12px; }
.dc-sec-h { font-size: 12px; color: var(--muted); margin-bottom: 8px; font-weight: 600; }
.dc-opts { display: grid; grid-template-columns: repeat(3,1fr); gap: 8px; }
.dc-opt { padding: 10px; border: 1px solid var(--border); border-radius: 10px; background: var(--bg); color: var(--fg); cursor: pointer; font-size: 12px; text-align: center; }
.dc-opt.on { border-color: #16a34a; color: #16a34a; }
.dc-kv { display: flex; justify-content: space-between; font-size: 12px; margin: 3px 0; }
.dc-kv .k { color: var(--muted); }
.dc-mono { font-family: ui-monospace, monospace; font-size: 11px; color: var(--fg); word-break: break-all; }
.dc-pill { background: #16a34a; color: #fff; border: none; border-radius: 9px; padding: 8px 12px; font-size: 13px; cursor: pointer; }
.dc-ghost { background: var(--card); color: var(--fg); border: 1px solid var(--border); border-radius: 9px; padding: 7px 12px; font-size: 12px; cursor: pointer; }

.dc-launcher { position: fixed; z-index: 2147483000; width: 56px; height: 56px; border-radius: 50%; border: none; cursor: pointer; color: #fff; font-size: 24px; box-shadow: 0 8px 24px rgba(109,49,230,.45); background-image: var(--grad); }
